<ng-select
  class="custom"
  [readonly]="readonly"
  [placeholder]="placeholder"
  [(ngModel)]="domain"
  [items]="domainList | async"
  [loading]="domainListLoading"
  [typeahead]="typeahead"
  (change)="onChange($event)"
  (open)="onOpen()">
  required
  <ng-template ng-label-tmp let-item="item">
    {{ item.code }}
    @if (item.code && item.name) {
      <span>: </span>
    }
    {{ item.name }}{{ item.parent?.code ? ' (' + item.parent.code + ')' : '' }}
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    {{ item.code }}: {{ item.name
    }}{{ item.parent ? ' (' + item.parent.code + ')' : '' }}
  </ng-template>
  @if (newDomainCode | async; as newCode) {
    <ng-template ng-header-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <button
          type="button"
          class="btn btn-link"
          (click)="openCreateDomainModal()"
          (keydown.enter)="openCreateDomainModal()">
          Create domain {{ newCode }}
        </button>
      </div>
    </ng-template>
  }

  @if (!domainListLoading) {
    <ng-template ng-footer-tmp>
      Showing {{ loadResultsCount }} of {{ loadResultsTotal }}
    </ng-template>
  }
</ng-select>
